import { Select } from "antd";
import { useEffect, useState } from "react";
import * as API from "@api";

export default function ArticleCategories(params) {
  const [data, setData] = useState([]);

  useEffect(() => {
    API.ArticleCategories.getAll({ limit: 1000 }).then((res) =>
      setData(
        res?.data?.rows?.map((val) => ({
          label: val?.name,
          value: val?.id,
        })) || []
      )
    );
  }, []);

  return (
    <Select
      mode="multiple"
      className="w-full"
      placeholder="Select Category"
      allowClear
      showSearch
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label ?? "").toLowerCase())
      }
      onChange={(v) => params.onChange("category_id", v)}
      options={data}
    />
  );
}
